import React, { useState } from 'react';
import { Redirect } from "react-router-dom";
import { Box, Typography } from '@material-ui/core';

import { MobileRegularPage } from '../../../components';

import { checkSignedIn } from "../../../services/auth.service";

import useStyles from "./HavePlanQuestion.style";

import icon from '../../../images/icon_haveplan.png'
import { AppButton } from '../components/InputComponents';
import Cookies from 'universal-cookie';


const cookies = new Cookies();

const HavePlanQuestion = () => {
    const classes = useStyles();

    const [moveForward, setMoveForward] = useState(false);

    const handleUsersChoice = answer => async () => {
        if (!await checkSignedIn()) {
            localStorage.setItem('havePlan', answer);
            setMoveForward(true);
            return;
        };
        try {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT}/saveplan`, {
                method: 'post',
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                },
                body: new URLSearchParams({
                    havePlan: answer
                })
            });
            let json = await response.json();
            if (!response.ok) console.log(json.message);
        } catch (error) {
            console.log(error);
        } finally {
            setMoveForward(true);
        };
    };

    if (moveForward) return <Redirect to="/app/signin" />

    return (
        <MobileRegularPage>
            <Box className={classes.root}>
                <Box><img className={classes.imageIcon} src={icon} alt="Page Icon" /></Box>
                <Typography variant="h4" className={classes.title}>Do you have a reproductive life plan?</Typography>
                <Typography className={classes.subTitle}>
                    Your Reproductive Life Plan is created through your own
                    goals of what to best fits your life, your health and your family.
                </Typography>
                <Box className={classes.buttonContainer}>
                    <AppButton
                        variant="contained"
                        color="secondary"
                        fullWidth
                        size="large"
                        onClick={handleUsersChoice(true)}
                    >
                        Yes, let's map it
                    </AppButton>
                    <AppButton
                        variant="contained"
                        color="secondary"
                        fullWidth
                        size="large"
                        onClick={handleUsersChoice(false)}
                    >
                        No, let's build it
                    </AppButton>
                </Box>
            </Box>
        </MobileRegularPage>
    );
};

export default HavePlanQuestion;